import { TypedDocumentNode, gql } from '@apollo/client';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  ConfirmImportLineup,
  ConfirmImportLineupVariables,
} from './__generated__/useConfirmImportLineup.graphql';

const CONFIRM_IMPORT_LINEUP_MUTATION = gql`
  mutation ConfirmImportLineup($input: confirmSo5LineupImportsBatchInput!) {
    confirmSo5LineupImportsBatch(input: $input) {
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<ConfirmImportLineup, ConfirmImportLineupVariables>;

export const useConfirmImportLineup = (id?: string | null) => {
  const [confirmImportLineup] = useMutation(CONFIRM_IMPORT_LINEUP_MUTATION, {
    variables: {
      input: {
        batchId: id!,
      },
    },
    showErrorsWithSnackNotification: true,
  });

  return confirmImportLineup;
};
